
export const CIRCLE = 'm-12.50001,0.54385c0,-7.20655 5.8373,-13.04385 13.04385,-13.04385c7.20655,0 13.04385,5.8373 13.04385,13.04385c0,7.20655 -5.8373,13.04385 -13.04385,13.04385c-7.20655,0 -13.04385,-5.8373 -13.04385,-13.04385z'
export const DROP = 'm9.72864,6.18447c0,5.21228 -4.34827,9.44253 -9.70596,9.44253c-5.35769,0 -9.80507,-4.2312 -9.70595,-9.44253c0.1317,-6.99036 5.4678,-9.83766 9.70595,-17.87197c4.50158,7.77089 9.70596,12.65969 9.70596,17.87197z'
export const RADIUS = 10.4


// WEBPACK FOOTER //
// ./src/utils/paths.js